import { Dialog, Transition } from "@headlessui/react";
import { XCircleIcon } from "@heroicons/react/24/solid";
import React, { Fragment } from "react";

interface HierarchyFormModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  title?: string;
  width?: string;
  hasCloseButton?: boolean;
  className?: string;
}
export const HierarchyFormModal: React.FC<HierarchyFormModalProps> = ({
  isOpen = false,
  onClose = () => {},
  width = "full",
  className = "",
  hasCloseButton = true,
  children,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-20 inset-0 overflow-hidden bg-black bg-opacity-40 py-10"
        onClose={() => {}}
      >
        <div className="min-h-full inset-0  px-10 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              className={`w-${width} inline-block border border-l-6 px-4 pb-3 pt-2 overflow-hidden 
          text-left align-middle transition-all 
          transform bg-white shadow-xl brContainer ${className} `}
            >
              <div>{children}</div>
              {hasCloseButton && (
                <div className="flex justify-end mt-3 mr-1">
                  <button
                    className="px-3 py-1 text-xs text-white gap-x-2 bg-btnClose rounded-full flex items-center 
                justify-center font-semibold hover:bg-gray-400 box-shadow"
                    onClick={onClose}
                  >
                    <XCircleIcon className="h-4 w-4" />
                    <div>Close</div>
                  </button>
                </div>
              )}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
